export default __webpack_public_path__ + "static/media/REAL CPI ASSET STIKER-04.eed74566.png";